import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../shared/theme/theme';

export const searchBarInputTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          display: 'block',
          flex: 1,
        },
      },
    },
  },
});
